import * as React from "react";

import type {Role, Step, UpdateStep} from "@repo/auth-shared";

import ProgressShellActionScreen from "../progress-shell/progress-shell-action-screen.tsx";

import LoginForm from "./login-form.tsx";

type Props = {
    classCode?: string;
    continueUrl?: string;
    previousStep?: Step;
    role?: Role;
    // Used by ProgressShell to coordinate which screens to render.
    updateStep: UpdateStep;
};

type DefaultProps = {
    role: Props["role"];
};

class LoginActionScreen extends React.Component<Props> {
    usernameInputField: HTMLInputElement | null | undefined;

    static defaultProps: DefaultProps = {
        role: "learner",
    };

    render(): React.ReactNode {
        const {previousStep, updateStep} = this.props;
        return (
            <ProgressShellActionScreen
                showBackButton={!!previousStep}
                onBackClick={
                    previousStep ? () => updateStep(previousStep) : () => {}
                }
                maxWidth={443}
            >
                <LoginForm
                    classCode={this.props.classCode}
                    continueUrl={this.props.continueUrl}
                    role={this.props.role}
                    loginTitleTag="h2"
                />
            </ProgressShellActionScreen>
        );
    }
}

export default LoginActionScreen;
